import { render } from "./CertificateCard.vue?vue&type=template&id=83ea85b8&scoped=true"
import script from "./CertificateCard.vue?vue&type=script&lang=js"
export * from "./CertificateCard.vue?vue&type=script&lang=js"

import "./CertificateCard.vue?vue&type=style&index=0&id=83ea85b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83ea85b8"]])

export default __exports__